@charset "UTF-8";

/* app/js/src/components/external-mam/external-mam-providers-setup/external-mam-providers-setup-step-two/external-mam-providers-setup-step-two.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  display: flex;
  padding: 25px;
  flex-direction: column;
  gap: 20px;
}
h2 {
  color: rgba(0, 0, 0, 0.85);
  font-family: Open Sans;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px;
}
.fields-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: auto;
  grid-column-gap: 20px;
  grid-row-gap: 30px;
}
::ng-deep mat-optgroup mat-option span:before {
  content: "\2022 	";
}
.error-msg {
  color: rgb(255, 76, 81);
}
/*# sourceMappingURL=external-mam-providers-setup-step-two.component.css.map */
